export default "__VITE_ASSET__VMLmZ_Al__"